import React, { useCallback } from "react";
import { FieldProps } from "react-jsonschema-form";
import InputGroup from "../witadmin/CRUD/Common/InputGroup";
import { defineMessages, FormattedMessage } from "react-intl";
import CheckboxGroup from "../witadmin/CRUD/Common/CheckBoxGroup";

const messages = defineMessages({
  maxAccommodationsMultiReservation: {
    id: "behaviourForm.label.maxAccommodationsMultiReservation",
    defaultMessage: "maxAccommodationsMultiReservation",
  },
  showMultipleAccommodations: {
    id: "behaviourForm.label.showMultipleAccommodations",
    defaultMessage: "showMultipleAccommodations",
  },
});

export default function MaxAccommodationsMultiReservation({ formData, onChange }: FieldProps) {
  const handleChange = useCallback(
    data => {
      const { field, event } = data;
      const value =
        field === "showMultipleAccommodations" ? event.target.checked : +event.target.value;
      onChange({
        ...formData,
        [field]: value,
      });
    },
    [formData, onChange]
  );

  return (
    <>
      <CheckboxGroup
        field={{
          className: "witadmin-bs3",
          fieldName: "showMultipleAccommodations",
          description: <FormattedMessage {...messages.showMultipleAccommodations} />,
          htmlFor: "root_showMultipleAccommodations",
          disabled: false,
        }}
        onChange={handleChange}
        value={formData?.showMultipleAccommodations}
      />
      {formData?.showMultipleAccommodations && (
        <div>
          <label htmlFor="root_maxAccommodationsMultiReservation">
            <FormattedMessage {...messages.maxAccommodationsMultiReservation} />
          </label>
          <InputGroup
            type="string"
            value={formData?.maxAccommodationsMultiReservation}
            field={{ fieldName: "maxAccommodationsMultiReservation" }}
            onChange={handleChange}
            disabled={false}
            readOnly={false}
          />
        </div>
      )}
    </>
  );
}
